import { __awaiter, __generator } from "tslib";
import { fetchFeatureGates } from '@office-start/feature-gates-service';
import { getWdOrigin } from '@office-start/file-utility';
import { DataSecurityLevel, } from '@office-start/instrumentation-types';
import { logFeature } from '@office-start/telemetry-service';
import { getContentTarget } from '../utilities/getContentTarget';
import { getLaunchInlineParams } from './getLaunchInlineParams';
import { getLaunchParams } from './getLaunchParams';
import { launchCustomContent } from './launchCustomContent';
import { launchUrlInWeb } from './launchUrlInWeb';
import { launchUrlWithDocument } from './launchUrlWithDocument';
import { logClick } from './logClick';
export function launchDocument(contentLaunchParams, launchInstrumentationParams) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return __awaiter(this, void 0, void 0, function () {
        var linkTarget, launchParams, context, document, useDeeplinkUrl, wdOriginType, launchInlineParams, result, contentLoadPromise, bootInlineResult, featureGates, _j, shouldHandleFluidContent, startTime, success, action;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    linkTarget = (_a = contentLaunchParams.linkTarget) !== null && _a !== void 0 ? _a : getContentTarget(contentLaunchParams.event, contentLaunchParams.inAppNavFileType, contentLaunchParams.isPwaInUwp);
                    logFeature({
                        featureName: "LauncherService" /* KnownFeatureNames.LauncherService */,
                        eventName: 'launchDocument',
                        params: {
                            debugInfo: "link target parameter for launcher service",
                            inAppNavFileType: (_c = (_b = contentLaunchParams.inAppNavFileType) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '',
                            isPwa: (_e = (_d = contentLaunchParams.isPwaInUwp) === null || _d === void 0 ? void 0 : _d.toString()) !== null && _e !== void 0 ? _e : '',
                            linkTarget: linkTarget,
                            linkTargetSource: contentLaunchParams.linkTarget
                                ? 'contentLaunchParams'
                                : 'getContentTarget',
                            wdOriginType: (_g = (_f = contentLaunchParams.wdOriginType) === null || _f === void 0 ? void 0 : _f.toString()) !== null && _g !== void 0 ? _g : '',
                        },
                        area: 'AppLauncher',
                        subArea: 'Document',
                    });
                    return [4 /*yield*/, getLaunchParams(contentLaunchParams)];
                case 1:
                    launchParams = _k.sent();
                    if (launchInstrumentationParams) {
                        if (launchParams.clickId) {
                            // Use this Id to correlate with WAC in case there is an error opening a document.
                            launchInstrumentationParams.clickParams["RequestId" /* InstrumentationParam.RequestId */] = launchParams.clickId;
                        }
                        launchInstrumentationParams.dataSecurityLevel = contentLaunchParams
                            .document.isLocalFile
                            ? DataSecurityLevel.Enhanced
                            : DataSecurityLevel.Security;
                        // Only wait to log click if we open in a new tab, otherwise we risk losing the event
                        if (linkTarget !== '_blank') {
                            logClick({
                                launchInstrumentationParams: launchInstrumentationParams,
                                success: true,
                                platform: 'Web',
                            });
                        }
                    }
                    context = launchParams.context;
                    document = contentLaunchParams.document, useDeeplinkUrl = contentLaunchParams.useDeeplinkUrl, wdOriginType = contentLaunchParams.wdOriginType;
                    return [4 /*yield*/, getLaunchInlineParams(document, launchParams.context, launchParams.capabilities, contentLaunchParams.event)];
                case 2:
                    launchInlineParams = _k.sent();
                    if (!(launchInlineParams.fluidHostFile &&
                        launchInstrumentationParams &&
                        contentLaunchParams &&
                        contentLaunchParams.linkTarget == '_blank')) return [3 /*break*/, 4];
                    return [4 /*yield*/, launchUrlWithDocument(document, context, launchInstrumentationParams, launchInlineParams.fluidHostFile)];
                case 3:
                    result = _k.sent();
                    logClick({
                        launchInstrumentationParams: launchInstrumentationParams,
                        success: result.success,
                        platform: 'Web',
                    });
                    result.result = 'NewTab';
                    return [2 /*return*/, result];
                case 4:
                    contentLoadPromise = launchCustomContent(contentLaunchParams, launchInlineParams, launchParams, launchInstrumentationParams);
                    return [4 /*yield*/, contentLoadPromise];
                case 5:
                    bootInlineResult = _k.sent();
                    if (!(bootInlineResult === null || bootInlineResult === void 0 ? void 0 : bootInlineResult.success)) return [3 /*break*/, 6];
                    return [2 /*return*/, bootInlineResult];
                case 6:
                    if (!launchInlineParams.fluidHostFile) return [3 /*break*/, 8];
                    return [4 /*yield*/, fetchFeatureGates()];
                case 7:
                    _j = _k.sent();
                    return [3 /*break*/, 9];
                case 8:
                    _j = undefined;
                    _k.label = 9;
                case 9:
                    featureGates = _j;
                    shouldHandleFluidContent = launchInlineParams.fluidHostFile &&
                        !((_h = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result.fluidConfigGates) === null || _h === void 0 ? void 0 : _h.fluidConfigOpenExternallyEnabled);
                    if (!((launchInlineParams.shouldHandleWacContent ||
                        shouldHandleFluidContent) &&
                        context.router.openHostedDocument)) return [3 /*break*/, 11];
                    startTime = Date.now();
                    return [4 /*yield*/, context.router.openHostedDocument(document, startTime, getWdOrigin(context.workload, context.router.getCurrentRoute(), wdOriginType), launchInlineParams.fluidHostFile, 'DocumentClick', useDeeplinkUrl && document.navId
                            ? { actnavid: document.navId }
                            : {})];
                case 10:
                    success = _k.sent();
                    logClick({
                        launchInstrumentationParams: launchInstrumentationParams,
                        success: success,
                        platform: 'Web',
                        uiHost: true,
                    });
                    return [2 /*return*/, {
                            success: success,
                            result: 'Inline',
                            message: 'launchDocument:openHostedDocument',
                        }];
                case 11:
                    action = 'OpenDocument';
                    if (!launchParams.webUrl) return [3 /*break*/, 13];
                    return [4 /*yield*/, launchUrlInWeb(action, launchParams.webUrl, launchInstrumentationParams, linkTarget)];
                case 12: return [2 /*return*/, _k.sent()];
                case 13: return [2 /*return*/, {
                        success: false,
                        message: 'launchDocument:fallThrough',
                    }];
            }
        });
    });
}
//# sourceMappingURL=launchDocument.js.map